import { permissionAccessor } from './permissionHelper'

export default function typeToPermission(type, operation, store){
    const typeNumber = Number(type)
    switch (typeNumber) {
        case 1:
            return permissionAccessor('inventory_variance_opening:' + operation, store)
        case 2:
            return permissionAccessor('inventory_variance_adjust_by_qty:' + operation, store)
        case 3:
            return permissionAccessor('inventory_variance_adjust_by_variance:' + operation, store)
        case 4:
            return permissionAccessor('inventory_variance_cost_adjustment:' + operation, store)
    }
}


/** WEBPACK FOOTER **
 ** ./client/helpers/typeToPermissionHelper.js
 **/